import React, { Component } from "react";
import {LogEvent} from '@learningblocks/shared-components';
import {Button} from '@learningblocks/shared-components';

import "./EndSimulation.scss";

import warningIcon from "./img/warning-modal-icon.svg";

export class EndSimulation extends Component {

  endSimulation = () => {
    this.props.showModal({display: false});
  };

  closePlatformDialog = () => {
    window.parent.postMessage({
      method: 'event',
      data: {type: 'requestClose'}
    }, '*');
    return false;
  }

  render() {
    return (
      <div className="modal-section endSimulationModal">
        <img alt="Warning icon." src={warningIcon} className="warningIcon" />
        <h3 className="heading">
          End Simulation
        </h3>
        <p className="endDescription">Are you sure you want to end this simulation?</p>
        <div className="modal-footer">
          <div onClick={this.closePlatformDialog}>
            <LogEvent
              logEventProps={{
                event_type: "sim_summary_finish_btn clicked",
                event_schema: "track"
              }}
              actionProps={{ onClick: { action: 'click' } }}
              elementType="button"
            >
              <Button className='endSimulation' onClick={this.endSimulation}>
              End Simulation
              </Button>
            </LogEvent>
          </div>
        </div>
      </div>
    );
  }
}
